const getMarginSize = (size: string) => {
  switch (size) {
    case 'Default-Medium':
      return 'bottom-margin';
    case 'Small':
      return 'bottom-margin-sm';
    case 'Large':
      return 'bottom-margin-lg';
    default:
      return '';
  }
};

export { getMarginSize };
